"use strict";
exports.__esModule = true;
exports.Events = exports.AuthMethod = exports.ScreenParent = exports.AppTab = exports.AccountType = exports.ContactDetailType = exports.ExerciseInteractionType = exports.ExerciseType = exports.AwardType = exports.MediaType = exports.ActivityProgressType = exports.ActivityType = exports.InteractionType = exports.ComponentLockType = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["ACTIVITY_COVER"] = "ACTIVITY_COVER";
    ComponentType["TUTOR_BADGE"] = "TUTOR_BADGE";
    ComponentType["LOCK"] = "LOCK";
    ComponentType["PAYWALL"] = "PAYWALL";
    ComponentType["SHELF"] = "SHELF";
    ComponentType["BUTTON"] = "BUTTON";
    ComponentType["MEDIA_VIDEO"] = "MEDIA_VIDEO";
    ComponentType["FREE_TEXT_BOX"] = "FREE_TEXT_BOX";
    ComponentType["SCREEN"] = "SCREEN";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var ComponentLockType;
(function (ComponentLockType) {
    ComponentLockType["LOCK_ON_COVER"] = "LOCK_ON_COVER";
})(ComponentLockType = exports.ComponentLockType || (exports.ComponentLockType = {}));
var InteractionType;
(function (InteractionType) {
    InteractionType["CLICK"] = "CLICK";
    InteractionType["TYPING"] = "TYPING";
    InteractionType["SCROLL"] = "SCROLL";
})(InteractionType = exports.InteractionType || (exports.InteractionType = {}));
var ActivityType;
(function (ActivityType) {
    ActivityType["READING"] = "READING";
    ActivityType["LISTENING"] = "LISTENING";
    ActivityType["TUTOR_SET"] = "TUTOR_SET";
    ActivityType["TUTOR_CHECK_IN"] = "TUTOR_CHECK_IN";
    ActivityType["PT_ONBOARDING"] = "PT_ONBOARDING";
    ActivityType["PLACEMENT_TEST"] = "PLACEMENT_TEST";
    ActivityType["POWER_UP"] = "POWER_UP";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
var ActivityProgressType;
(function (ActivityProgressType) {
    ActivityProgressType["SECTION_STARTED"] = "SECTION_STARTED";
    ActivityProgressType["SECTION_COMPLETED"] = "SECTION_COMPLETED";
    ActivityProgressType["START_TUTOR_FEEDBACK"] = "START_TUTOR_FEEDBACK";
})(ActivityProgressType = exports.ActivityProgressType || (exports.ActivityProgressType = {}));
var MediaType;
(function (MediaType) {
    MediaType["AUDIO"] = "AUDIO";
    MediaType["VIDEO"] = "VIDEO";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var AwardType;
(function (AwardType) {
    AwardType["STAR"] = "STAR";
    AwardType["LEVEL_UP"] = "LEVEL_UP";
    AwardType["ACHIEVEMENT"] = "ACHIEVEMENT";
})(AwardType = exports.AwardType || (exports.AwardType = {}));
var ExerciseType;
(function (ExerciseType) {
    ExerciseType["WORLD_BUILDER"] = "WORLD_BUILDER";
    ExerciseType["MULTI_CHOICE_QUESTION"] = "MULTI_CHOICE_QUESTION";
    ExerciseType["CONVERSATION"] = "CONVERSATION";
    ExerciseType["READ_SENTENCE"] = "READ_SENTENCE";
    ExerciseType["READ_WORD_RACE"] = "READ_WORD_RACE";
    ExerciseType["WORD_PRACTICE"] = "WORD_PRACTICE";
    ExerciseType["SENTENCE_BUILDER"] = "SENTENCE_BUILDER";
    ExerciseType["OTHER"] = "OTHER";
})(ExerciseType = exports.ExerciseType || (exports.ExerciseType = {}));
var ExerciseInteractionType;
(function (ExerciseInteractionType) {
    ExerciseInteractionType["RECORD_MEDIA"] = "RECORD_MEDIA";
    ExerciseInteractionType["SELECT_ANSWER"] = "SELECT_ANSWER";
    ExerciseInteractionType["DRAG_DROP"] = "DRAG_DROP";
})(ExerciseInteractionType = exports.ExerciseInteractionType || (exports.ExerciseInteractionType = {}));
var ContactDetailType;
(function (ContactDetailType) {
    ContactDetailType["PHONE"] = "PHONE";
    ContactDetailType["EMAIL"] = "EMAIL";
})(ContactDetailType = exports.ContactDetailType || (exports.ContactDetailType = {}));
var AccountType;
(function (AccountType) {
    AccountType["LEARNER"] = "LEARNER";
    AccountType["TUTOR"] = "TUTOR";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AppTab;
(function (AppTab) {
    AppTab["APP_TAB_JOURNEY"] = "APP_TAB_JOURNEY";
    AppTab["APP_TAB_LIBRARY"] = "APP_TAB_LIBRARY";
    AppTab["APP_TAB_PRONUNCIATION"] = "APP_TAB_PRONUNCIATION";
})(AppTab = exports.AppTab || (exports.AppTab = {}));
var ScreenParent;
(function (ScreenParent) {
    ScreenParent["APP"] = "APP";
    ScreenParent["TUTOR_SET"] = "TUTOR_SET";
    ScreenParent["TUTOR_CHECK_IN"] = "TUTOR_CHECK_IN";
    ScreenParent["PT_ONBOARDING"] = "PT_ONBOARDING";
    ScreenParent["ONBOARDING"] = "ONBOARDING";
    ScreenParent["POWER_UP"] = "POWER_UP";
})(ScreenParent = exports.ScreenParent || (exports.ScreenParent = {}));
var AuthMethod;
(function (AuthMethod) {
    AuthMethod["EMAIL"] = "EMAIL";
    AuthMethod["PHONE"] = "PHONE";
    AuthMethod["GOOGLE"] = "GOOGLE";
    AuthMethod["APPLE"] = "APPLE";
    AuthMethod["FACEBOOK"] = "FACEBOOK";
})(AuthMethod = exports.AuthMethod || (exports.AuthMethod = {}));
var Events;
(function (Events) {
    var ScreenShown = (function () {
        function ScreenShown(struct) {
            this.struct = struct;
            this.name = 'Screen Shown';
            this.props = Object.freeze({
                schema_version: 2,
                screen_parent: this.struct.screen_parent,
                screen_name: this.struct.screen_name
            });
        }
        return ScreenShown;
    }());
    Events.ScreenShown = ScreenShown;
    var ComponentShown = (function () {
        function ComponentShown(struct) {
            this.struct = struct;
            this.name = 'Component Shown';
            this.props = Object.freeze({
                schema_version: 2,
                component_type: this.struct.component_type,
                component_name: this.struct.component_name,
                clickable: this.struct.clickable,
                component_value: this.struct.component_value,
                screen_name: this.struct.screen_name,
                lock: this.struct.lock
            });
        }
        return ComponentShown;
    }());
    Events.ComponentShown = ComponentShown;
    var InteractionTaken = (function () {
        function InteractionTaken(struct) {
            this.struct = struct;
            this.name = 'Interaction Taken';
            this.props = Object.freeze({
                schema_version: 2,
                screen_name: this.struct.screen_name,
                interaction_type: this.struct.interaction_type,
                component_type: this.struct.component_type,
                component_name: this.struct.component_name,
                component_value: this.struct.component_value,
                interaction_value: this.struct.interaction_value
            });
        }
        return InteractionTaken;
    }());
    Events.InteractionTaken = InteractionTaken;
    var ActivityStarted = (function () {
        function ActivityStarted(struct) {
            this.struct = struct;
            this.name = 'Activity Started';
            this.props = Object.freeze({
                schema_version: 2,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                activity_screen_name: this.struct.activity_screen_name,
                from: this.struct.from,
                from_shelf: this.struct.from_shelf
            });
        }
        return ActivityStarted;
    }());
    Events.ActivityStarted = ActivityStarted;
    var ActivityResumed = (function () {
        function ActivityResumed(struct) {
            this.struct = struct;
            this.name = 'Activity Resumed';
            this.props = Object.freeze({
                schema_version: 2,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                activity_screen_name: this.struct.activity_screen_name,
                from: this.struct.from,
                from_shelf: this.struct.from_shelf
            });
        }
        return ActivityResumed;
    }());
    Events.ActivityResumed = ActivityResumed;
    var ActivityCompleted = (function () {
        function ActivityCompleted(struct) {
            this.struct = struct;
            this.name = 'Activity Completed';
            this.props = Object.freeze({
                schema_version: 2,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                activity_result: this.struct.activity_result,
                from: this.struct.from
            });
        }
        return ActivityCompleted;
    }());
    Events.ActivityCompleted = ActivityCompleted;
    var ActivityProgressed = (function () {
        function ActivityProgressed(struct) {
            this.struct = struct;
            this.name = 'Activity Progressed';
            this.props = Object.freeze({
                schema_version: 2,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                progress_type: this.struct.progress_type,
                progress_value: this.struct.progress_value
            });
        }
        return ActivityProgressed;
    }());
    Events.ActivityProgressed = ActivityProgressed;
    var MediaStarted = (function () {
        function MediaStarted(struct) {
            this.struct = struct;
            this.name = 'Media Started';
            this.props = Object.freeze({
                schema_version: 2,
                source: this.struct.source,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                media_title: this.struct.media_title,
                media_id: this.struct.media_id
            });
        }
        return MediaStarted;
    }());
    Events.MediaStarted = MediaStarted;
    var MediaDisrupted = (function () {
        function MediaDisrupted(struct) {
            this.struct = struct;
            this.name = 'Media Disrupted';
            this.props = Object.freeze({
                schema_version: 2,
                source: this.struct.source,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                media_title: this.struct.media_title,
                media_id: this.struct.media_id,
                disrupt_reason: this.struct.disrupt_reason
            });
        }
        return MediaDisrupted;
    }());
    Events.MediaDisrupted = MediaDisrupted;
    var RecordingStarted = (function () {
        function RecordingStarted(struct) {
            this.struct = struct;
            this.name = 'Recording Started';
            this.props = Object.freeze({
                schema_version: 2,
                source: this.struct.source,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                recording_title: this.struct.recording_title
            });
        }
        return RecordingStarted;
    }());
    Events.RecordingStarted = RecordingStarted;
    var RecordingEnded = (function () {
        function RecordingEnded(struct) {
            this.struct = struct;
            this.name = 'Recording Ended';
            this.props = Object.freeze({
                schema_version: 2,
                source_type: this.struct.source_type,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                recording_title: this.struct.recording_title,
                recording_length_sec: this.struct.recording_length_sec
            });
        }
        return RecordingEnded;
    }());
    Events.RecordingEnded = RecordingEnded;
    var RecordingSent = (function () {
        function RecordingSent(struct) {
            this.struct = struct;
            this.name = 'Recording Sent';
            this.props = Object.freeze({
                schema_version: 2,
                source_type: this.struct.source_type,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                recording_title: this.struct.recording_title,
                recording_length_sec: this.struct.recording_length_sec
            });
        }
        return RecordingSent;
    }());
    Events.RecordingSent = RecordingSent;
    var AwardEarned = (function () {
        function AwardEarned(struct) {
            this.struct = struct;
            this.name = 'Awarded Earned';
            this.props = Object.freeze({
                schema_version: 2,
                award_type: this.struct.award_type,
                award_name: this.struct.award_name,
                award_value: this.struct.award_value,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id
            });
        }
        return AwardEarned;
    }());
    Events.AwardEarned = AwardEarned;
    var ExerciseStarted = (function () {
        function ExerciseStarted(struct) {
            this.struct = struct;
            this.name = 'Exercise Started';
            this.props = Object.freeze({
                schema_version: 2,
                exercise_type: this.struct.exercise_type,
                exercise_title: this.struct.exercise_title,
                exercise_id: this.struct.exercise_id,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id
            });
        }
        return ExerciseStarted;
    }());
    Events.ExerciseStarted = ExerciseStarted;
    var ExerciseInteracted = (function () {
        function ExerciseInteracted(struct) {
            this.struct = struct;
            this.name = 'Exercise Interacted';
            this.props = Object.freeze({
                schema_version: 2,
                exercise_type: this.struct.exercise_type,
                exercise_title: this.struct.exercise_title,
                exercise_id: this.struct.exercise_id,
                interaction_type: this.struct.interaction_type,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                score: this.struct.score
            });
        }
        return ExerciseInteracted;
    }());
    Events.ExerciseInteracted = ExerciseInteracted;
    var ExerciseCompleted = (function () {
        function ExerciseCompleted(struct) {
            this.struct = struct;
            this.name = 'Exercise Completed';
            this.props = Object.freeze({
                schema_version: 2,
                exercise_type: this.struct.exercise_type,
                exercise_title: this.struct.exercise_title,
                exercise_id: this.struct.exercise_id,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                exercise_score: this.struct.exercise_score
            });
        }
        return ExerciseCompleted;
    }());
    Events.ExerciseCompleted = ExerciseCompleted;
    var ContactDetailsSubmitted = (function () {
        function ContactDetailsSubmitted(struct) {
            this.struct = struct;
            this.name = 'Contact Info Submitted';
            this.props = Object.freeze({
                schema_version: 2,
                location: this.struct.location,
                detail_type: this.struct.detail_type,
                detail: this.struct.detail
            });
        }
        return ContactDetailsSubmitted;
    }());
    Events.ContactDetailsSubmitted = ContactDetailsSubmitted;
    var AccountCreated = (function () {
        function AccountCreated(struct) {
            this.struct = struct;
            this.name = 'Account Created';
            this.props = Object.freeze({
                schema_version: 3,
                account_type: this.struct.account_type,
                userId: this.struct.userId,
                signup_method: this.struct.signup_method,
                account_id: this.struct.account_id
            });
        }
        return AccountCreated;
    }());
    Events.AccountCreated = AccountCreated;
    var AppFeatureConfigSent = (function () {
        function AppFeatureConfigSent(struct) {
            this.struct = struct;
            this.name = 'App Feature Config Sent';
            this.props = Object.freeze({
                schema_version: 2,
                enable_time_lock: this.struct.enable_time_lock,
                accessible_tabs: this.struct.accessible_tabs
            });
        }
        return AppFeatureConfigSent;
    }());
    Events.AppFeatureConfigSent = AppFeatureConfigSent;
    var ExperimentStatusDetermined = (function () {
        function ExperimentStatusDetermined(struct) {
            this.struct = struct;
            this.name = 'Experiment Status Determined';
            this.props = Object.freeze({
                schema_version: 2,
                ongoing_experiments_json: this.struct.ongoing_experiments_json
            });
        }
        return ExperimentStatusDetermined;
    }());
    Events.ExperimentStatusDetermined = ExperimentStatusDetermined;
    var ExperimentAssignmentCreated = (function () {
        function ExperimentAssignmentCreated(struct) {
            this.struct = struct;
            this.name = 'Experiment Assignment Created';
            this.props = Object.freeze({
                schema_version: 2,
                experiment_name: this.struct.experiment_name,
                assigned_variant: this.struct.assigned_variant
            });
        }
        return ExperimentAssignmentCreated;
    }());
    Events.ExperimentAssignmentCreated = ExperimentAssignmentCreated;
})(Events = exports.Events || (exports.Events = {}));
//# sourceMappingURL=event-schema.js.map